/**
* Chosen
* @type {Boolean}
*/
$('.chosen').chosen({
  allow_single_deselect: true,
  no_results_text: "Oops, nada encontrado."
});



//////////////////
// WEBPACK FOOTER
// ./src/javascripts/config.chosen.js
// module id = 19
// module chunks = 0